import Model from './Model';

export default class VendorAffiliateFunnel extends Model {
  // eslint-disable-next-line class-methods-use-this
  resource() {
    return 'vendor-affiliate-funnels';
  }
}
